/// <amd-module name="SuiteCommerce.AdvancedSignUp.Utils"/>
define("SuiteCommerce.AdvancedSignUp.Utils", ["require", "exports", "Utils"], function (require, exports, UtilSC) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Utils = void 0;
    var Utils = /** @class */ (function () {
        function Utils() {
        }
        Utils.isSingleDomain = function () {
            return UtilSC.isSingleDomain();
        };
        Utils.getCountries = function () {
            return SC.ENVIRONMENT.siteSettings.countries;
        };
        Utils.getAbsoluteUrl = function (file, isServices2) {
            return UtilSC.getAbsoluteUrl(file, isServices2);
        };
        Utils.translate = function (text) {
            return UtilSC.translate(text);
        };
        return Utils;
    }());
    exports.Utils = Utils;
});
